<template>
  <li>
    <router-link :to="{
        name: 'note-editor',
        params: {id: note.uuid},
        query: $route.query,
      }">
      <h3 v-if="note.summary">{{ note.summary }}</h3>
      <h3 v-else><i>Empty note</i></h3>
      <span>Updated {{ note.updated | relativeDate }}</span>
      <div
          v-if="note.todoProgress && note.todoProgress.total > 0"
          class="todo-status">
        <div class="todo-progress">
          <div
              class="todo-progress-bar"
              :style="{
                width: `${note.todoProgress.done / note.todoProgress.total * 100}%`
              }">
          </div>
        </div>
        <div
            v-if="note.todoProgress.done < note.todoProgress.total"
            class="todo-progress-text">
          {{ note.todoProgress.done }}/{{ note.todoProgress.total }}
        </div>
        <div
            v-else
            class="icon">
          done
        </div>
      </div>
    </router-link>
  </li>
</template>

<script>
import Note from '@/models/note.model';

export default {
  name: 'sidebar-entry',
  props: {
    note: {
      type: Note,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

li {
  border-bottom: 0.0625rem solid $dark-gray-900;

&:last-child {
    margin-bottom: -0.0625rem;
  }

  a {
    background: $dark-gray-700;
    display: block;
    padding: 0.625rem 1.25rem;
    position: relative;
    transition: background .2s;

    &::before {
      background: transparent;
      bottom: 0;
      content: '';
      left: 0;
      pointer-events: none;
      position: absolute;
      top: 0;
      transition: background .2s;
      width: 0.25rem;
    }

    &.router-link-active {
      &::before {
        background: $primary-600;
      }
    }

    &:hover {
      background: $dark-gray-400;

      .todo-status {
        .todo-progress {
          background: $dark-gray-100;
        }
      }
    }

    h3 {
      color: $text;
      font-weight: normal;
      word-wrap: break-word;
    }

    span {
      color: $secondary-text;
      font-size: 0.875rem;
    }

    .todo-status {
      align-items: center;
      display: flex;
      height: 1.5rem;
      margin-top: 0.5rem;

      .todo-progress {
        background: $dark-gray-400;
        border-radius: 0.125rem;
        flex-grow: 1;
        height: 0.375rem;
        margin-right: 0.5rem;
        overflow: hidden;
        position: relative;
        transition: background .2s;

        .todo-progress-bar {
          background: $primary-700;
          border-radius: 0.125rem;
          bottom: 0;
          left: 0;
          position: absolute;
          top: 0;
          transition: width .2s;
        }
      }

      .todo-progress-text {
        font-size: 0.875rem;
        line-height: 0.875rem;
      }

      .icon {
        $size: 1.25rem;
        color: $primary-600;
        font-size: $size;
        height: $size;
        line-height: $size;
        width: $size;
      }
    }
  }
}
</style>
